import {
  ALERT_SEVERITIES,
  SEVERITY_MAP,
  FLOW_THRESHOLD_STATUS,
  FLOW_CONDITION_TYPES
} from '@kentik/ui-shared/alerting/constants';

const defaultCondition = {
  type: FLOW_CONDITION_TYPES.STATIC,
  operator: 'greaterThanOrEquals',
  value_select: 'metric_0',
  comparisonValue: 0,
  ratioSettings: {}
};

const defaultThreshold = {
  severity: SEVERITY_MAP.MAJOR.STANDARD_ALERT,
  status: FLOW_THRESHOLD_STATUS.DISABLED,
  activate: { times: 5, timeWindow: 2, gracePeriod: 20, timeUnit: 'hour' },
  conditions: [defaultCondition],
  mitigations: [],
  notificationChannels: []
};

function deserialize(policy) {
  const { thresholds = [] } = policy;
  const { thresholdID, description, ...templateThreshold } = thresholds[0] || defaultThreshold;

  const initThresholds = ALERT_SEVERITIES.map((severity) => {
    const existingThreshold = thresholds.find((threshold) => threshold.severity === severity);
    if (existingThreshold) {
      // Preserve existing threshold with its already-deserialized uiProperties
      return existingThreshold;
    }

    const defaultEnabled = severity === SEVERITY_MAP.MAJOR.STANDARD_ALERT && thresholds.length === 0;
    const newThreshold = {
      ...templateThreshold,
      severity,
      // If there are no enabled thresholds, then enable Major by default
      ackRequired: false,
      filters: null,
      mitigations: [],
      notificationChannels: [],
      conditions: [],
      uiProperties: {
        enabled: defaultEnabled
      }
    };

    newThreshold.uiProperties = Object.assign({}, templateThreshold.uiProperties, { enabled: defaultEnabled });

    return newThreshold;
  });

  return { ...policy, thresholds: initThresholds };
}

function serialize(policy) {
  return policy;
}

export default {
  serialize,
  deserialize
};
